import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';
import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { Img } from '@sorare/core/src/atoms/ui/Img';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';
import { LatestNewsWidget } from '@sorare/gameplay/src/components/home/LatestNewsWidget';

import { articles } from './data.tsx';

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--quadruple-unit);
  @media ${tabletAndAbove} {
    flex-direction: row;
    gap: calc(var(--unit) * 10);
  }
`;

const ImgCtn = styled(Vertical).attrs({
  center: true,
})`
  width: calc(var(--unit) * 15);
  min-height: 120px;
  padding: var(--unit);
  border-radius: var(--unit);
  background-color: var(--c-nd-900-opaque);
  transition: transform 0.1s ease-in-out;

  &:hover {
    background-color: var(--c-white);
    transform: scale(1.05);
  }
`;

const PressContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  justify-items: center;
  gap: var(--triple-unit);
  @media ${tabletAndAbove} {
    grid-template-columns: repeat(2, 1fr);
    @media ${laptopAndAbove} {
      grid-template-columns: repeat(3, 1fr);
    }
    transition: grid-template-columns 0.3s ease-in-out;
  }
`;

export const InTheNews = () => {
  const isLaptop = useIsLaptop();
  return (
    <Container maxWidth={isLaptop ? 800 : 500}>
      <InnerContainer>
        <Vertical gap={2}>
          <BrandM>
            <FormattedMessage defaultMessage="In the news" />
          </BrandM>
          <PressContainer>
            {articles.map(article => (
              <Link key={article.name} to={article.href} target="_blank">
                <ImgCtn>
                  <Img src={article.svgUrl} alt={article.name} />
                </ImgCtn>
              </Link>
            ))}
          </PressContainer>
        </Vertical>
        <LatestNewsWidget />
      </InnerContainer>
    </Container>
  );
};
